import { differenceInCalendarDays } from "./differenceInCalendarDays.js";
import { startOfYear } from "./startOfYear.js";
import { toDate } from "./toDate.js";
/**
 * The {@link getDayOfYear} function options.
 */

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */

export function getDayOfYear(date, options) {
  var _date = toDate(date, options === null || options === void 0 ? void 0 : options.in);

  var diff = differenceInCalendarDays(_date, startOfYear(_date));
  var dayOfYear = diff + 1;
  return dayOfYear;
} // Fallback for modularized imports:

export default getDayOfYear;